import { normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c059a466"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TheInput__wrap" }
const _hoisted_2 = ["autocomplete", "value", "type", "disabled", "placeholder", "min", "max", "step"]
const _hoisted_3 = {
  key: 0,
  class: "floating-placeholder"
}
const _hoisted_4 = {
  key: 0,
  class: "TheInput__error"
}
const _hoisted_5 = {
  key: 1,
  class: "hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["TheInput", { 'TheInput--static': _ctx.isStatic }])
    }, [
      _withDirectives(_createElementVNode("input", {
        class: _normalizeClass(["TheInput__control", { invalid: _ctx.isInvalid, disabled: _ctx.disabled, withplaceholder: Boolean(_ctx.placeholder) }]),
        autocomplete: _ctx.autocomplete,
        value: _ctx.value,
        type: _ctx.type,
        disabled: _ctx.disabled,
        placeholder: _ctx.placeholder,
        min: _ctx.min,
        max: _ctx.max,
        step: _ctx.step,
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitInput && _ctx.emitInput(...args))),
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitChange && _ctx.emitChange(...args)))
      }, null, 42, _hoisted_2), [
        [_directive_maska, _ctx.maska]
      ]),
      (Boolean(_ctx.placeholder))
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(_ctx.placeholder), 1))
        : _createCommentVNode("", true)
    ], 2),
    (Boolean(_ctx.validationErrors.length) || Boolean(_ctx.validationErrorStr))
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
          (_ctx.validationErrorStr)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.validationErrorStr), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.getValidationMessage(_ctx.validationErrors)), 1)
              ], 64))
        ]))
      : _createCommentVNode("", true),
    (_ctx.withTooltip && _ctx.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.value), 1))
      : _createCommentVNode("", true)
  ]))
}